import { get, isEmpty, isNil } from 'lodash';
import moment from 'moment';
import {
  EXPERTISE_ACCOUNTING_ID,
  EXPERTISE_MEDICAL_ID,
} from 'containers/CourtManagerLegalProceedings/constants';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { VICTIM_EXPERTISE_FIELDS } from 'containers/data-structure';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { COMPTABLE_EXPERTISE_ID } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { CURRENT_JUDICIARY_STEP_EXPERT_REPORT } from 'containers/CourtManagerLegalProceedings/ExpertReportAppeal/constants';
import {
  getVictimAge,
  getVictimKey,
  getVictimRevenu,
} from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import { MODE } from 'containers/CourtManagerLegalProceedings/ExpertReport/constants';
export const renderTitleCustomAccordion = (recap: any) => {
  if (
    (Number(get(recap, 'mission.type', '')) === EXPERTISE_ACCOUNTING_ID &&
      !isEmpty(get(recap, 'mission.victims', []))) ||
    Number(get(recap, 'mission.type', '')) === EXPERTISE_MEDICAL_ID
  ) {
    return get(recap, 'type', '') === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
      ? 'APPRECIATION DE: VICTIM ' +
          `${recap?.victim?.firstName} ${recap?.victim?.lastName} - ` +
          moment(recap.createdAt).format('DD/MM/YYYY')
      : 'VICTIME ' +
          `${recap?.victim?.firstName} ${recap?.victim?.lastName} - ` +
          moment(recap.createdAt).format('DD/MM/YYYY');
  } else {
    return get(recap, 'type', '') === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
      ? 'APPRECIATION DE: VEHICULE ' +
          `${get(recap, 'mission.vehicles[0].registrationNumber', '')} - ` +
          moment(recap.createdAt).format('DD/MM/YYYY')
      : 'VEHICULE ' +
          `${get(recap, 'mission.vehicles[0].registrationNumber', '')} - ` +
          moment(recap.createdAt).format('DD/MM/YYYY');
  }
};

export const getExpertiseSagisEvaluationTransaction = (
  allExpertReport: any,
  expertReportProps: any,
  responsibilityShare: any,
  victims: any,
  lossDate: any,
) => {
  return expertReportProps.map((vicExp: any) => {
    const lastAccountingExpertise =
      get(allExpertReport, 'victimExpertises', []).find(
        (item: any) =>
          item?.victim.id === vicExp?.victim.id &&
          item.status === STATUS_VALIDATED &&
          String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
      ) || {};
    return {
      gestionMode: '',
      materialAmount: '',
      currentJudiciaryStep: CURRENT_JUDICIARY_STEP_EXPERT_REPORT,
      judiciaryAmount: '',
      responsibilityRate:
        (vicExp.isDeathRelatedToClaim === null ||
          vicExp.isDeathRelatedToClaim === false) &&
        Number(vicExp.expertiseId) === 1 &&
        vicExp.itt === null
          ? 0
          : responsibilityShare,
      rateRecovery: vicExp[VICTIM_EXPERTISE_FIELDS.THIRD_PARTY_APPEAL],
      revenu: vicExp[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]
        ? vicExp[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]
        : !isEmpty(lastAccountingExpertise)
        ? lastAccountingExpertise[VICTIM_EXPERTISE_FIELDS.FIXED_ANNUAL_INCOME]
        : !isNil(getVictimRevenu(vicExp?.victim.id, victims || []))
        ? getVictimRevenu(vicExp?.victim.id, victims || [])
        : vicExp[VICTIM_EXPERTISE_FIELDS.VICTIM_REVENUE],
      age: getVictimAge(vicExp?.victim.id, victims || [], lossDate),
      lossDate: moment(lossDate).toISOString(true),
      mode:
        vicExp?.victim?.injuryPostKey === INJURY_POST_DECEASED
          ? MODE.DECEASED
          : MODE.BLESSE,
      ratePretium: vicExp[VICTIM_EXPERTISE_FIELDS.PRETIUM_DOLORIS],
      rateAestheticDamageWithoutConsequence:
        vicExp[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITHOUT_CONSEQUENCE],
      rateAestheticDamageWithConsequence:
        vicExp[VICTIM_EXPERTISE_FIELDS.AESTHETIC_DAMAGE_WITH_CONSEQUENCE],
      rateCareerPrejudice: vicExp[VICTIM_EXPERTISE_FIELDS.CAREER_PREJUDICE],
      rateSchoolingPrejudice:
        vicExp[VICTIM_EXPERTISE_FIELDS.SCHOOLING_PREJUDICE],
      rateIPP: vicExp[VICTIM_EXPERTISE_FIELDS.IPP],
      rateITT: vicExp[VICTIM_EXPERTISE_FIELDS.ITT],
      victimKey: getVictimKey(vicExp?.victim.id as string, victims || []),
      medicalPharmaceuticalFees:
        vicExp[VICTIM_EXPERTISE_FIELDS.MEDICAL_PHARMACEUTICAL_FEES],
      rateMedicalPharmaceuticalFees: '',
      transactionPhase: 0,
      JudiciartDecisionDate: null,
      expType: 1,
      isRecentExpertiseVictim: true,
    };
  });
};
